import $ from "jquery";
let $document;

let BaseModal;
let Dispatcher;
let DownloadStore;
let Metrics;
let ProcessButton;
let React;
let UserStore;

React = require("react");

Dispatcher = require("../dispatcher/dispatcher").default;

UserStore = require("../stores/userstore").default;

DownloadStore = require("../stores/downloadstore").default;

BaseModal = require("../components/basemodal").default;

Metrics = require("../helpers/metrics").default;

ProcessButton = require("../components/processbutton").default;

$document = require("../helpers/helpers").default.document;

class RegisterForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {}
        };
    }

    componentDidMount() {
        return new Metrics().signup_form("basic");
    }

    render() {
        let err,
            fld,
            errors = this.props.errors,
            fields = {
                email: {
                    className: "",
                    labelClassName: "show",
                    placeholderText: "Email",
                    labelText: "Email"
                },
                password1: {
                    className: "",
                    labelClassName: "show",
                    placeholderText: "Password",
                    labelText: "Password"
                },
                accept_terms: {
                    className: "",
                    labelClassName: "must-agree",
                    labelText: ""
                }
            };

        for (fld in errors) {
            err = errors[fld];
            fields[fld].className += " error on";
            fields[fld].labelClassName += " error on";
            fields[fld].labelText = err;
        }

        return (
            <div id="signup">
                <section
                    id="form-container"
                    className="signup-styles columns five"
                >
                    <h2 className="auth-headline">Join to download</h2>
                    <form
                        id="create-account"
                        action="/accounts/signup/"
                        method="POST"
                        className="new-form dark-form form-basic"
                    >
                        <ol className="sign-up-fields">
                            <li>
                                <input
                                    tabIndex="3"
                                    id="id_email"
                                    className={fields.email.className}
                                    name="email"
                                    placeholder={fields.email.placeholderText}
                                    onFocus={this.props.clearErrors}
                                    autoComplete="off"
                                    type="text"
                                    autoFocus
                                />
                                <label
                                    htmlFor="id_email"
                                    className={fields.email.labelClassName}
                                >
                                    {fields.email.labelText}
                                </label>
                                <label
                                    htmlFor="id_email"
                                    className="ui_icon ui_email"
                                />
                            </li>

                            <li>
                                <input
                                    tabIndex="4"
                                    id="id_password1"
                                    className={fields.password1.className}
                                    name="password1"
                                    placeholder={
                                        fields.password1.placeholderText
                                    }
                                    onFocus={this.props.clearErrors}
                                    autoComplete="off"
                                    type="password"
                                />
                                <label
                                    htmlFor="id_password1"
                                    className={fields.password1.labelClassName}
                                >
                                    {fields.password1.labelText}
                                </label>
                                <label
                                    htmlFor="id_password1"
                                    className="ui_icon ui_lock"
                                />
                            </li>
                            <li className="margin-t-xl margin-l-m">
                                <label
                                    htmlFor="receive_updates"
                                    className="display-flex flex-align-center flex-justify-start check-box-label-container"
                                >
                                    <input
                                        id="receive_updates"
                                        name="receive_updates"
                                        className="checkbox-input"
                                        type="checkbox"
                                        defaultChecked="true"
                                    />
                                    <label
                                        htmlFor="receive_updates"
                                        className="checkbox-fillin"
                                    >
                                        <i className="ui_check-mark" />
                                    </label>
                                    <span>
                                        Send me occasional emails about the
                                        Noun&nbsp;Project community.
                                    </span>
                                </label>
                            </li>

                            <li className="margin-l-m">
                                <label
                                    htmlFor="accept_terms"
                                    className="display-flex flex-align-center flex-justify-start check-box-label-container"
                                >
                                    <input
                                        id="accept_terms"
                                        className="checkbox-input"
                                        name="accept_terms"
                                        type="checkbox"
                                        onChange={this.props.clearErrors}
                                        required
                                    />
                                    <label
                                        htmlFor="accept_terms"
                                        className="checkbox-fillin"
                                    >
                                        <i className="ui_check-mark" />
                                    </label>
                                    <span>
                                        I agree to the{" "}
                                        <a
                                            href="/legal/#!terms-of-use/"
                                            className="text-link color-white"
                                        >
                                            Terms of Use
                                        </a>.
                                    </span>
                                </label>
                                <label
                                    htmlFor="accept_terms"
                                    className="signup-errors"
                                >
                                    {fields.accept_terms.labelText}
                                </label>
                            </li>
                        </ol>
                        <ol className="sign-up-buttons margin-t-m">
                            <li>
                                <ProcessButton
                                    callback={this.props.doLogin}
                                    resetState={this.props.confirmAuth}
                                    buttonState={this.props.authStatus}
                                    buttonText="Create my account"
                                    iconClass="ui_user"
                                    extraClass="full-width"
                                    color="green"
                                />
                            </li>
                        </ol>
                        <input
                            type="hidden"
                            id="id_signup_type"
                            name="signup_type"
                            value="basic"
                        />
                    </form>
                </section>
                <section
                    className="columns five offset-two"
                    style={{ textAlign: "center" }}
                >
                    <img
                        className="margin-t-xl"
                        src={require("../../../img/auth/noun_project_logo@2x.png")}
                        width="127"
                        height="50"
                    />

                    <div
                        className="rotating-icons-container margin-t-l"
                        style={{
                            width: "100%",
                            height: "200px",
                            overflow: "hidden",
                            position: "relative"
                        }}
                    >
                        <style>{`
                            .rotating-icons-container::before{
                                content: '';
                                height: 100%;
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 50px;
                                background: linear-gradient(to right, rgba(0,0,0,1), rgba(0,0,0,0));
                                z-index: 1;
                            }
                            .rotating-icons-container::after{
                                content: '';
                                height: 100%;
                                position: absolute;
                                right: 0;
                                top: 0;
                                width: 50px;
                                background: linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,1));
                            }
                        `}</style>
                        <h1
                            className="font-medium weight-medium"
                            style={{
                                position: "absolute",
                                bottom: "24px",
                                left: "50%",
                                transform: "translateX(-50%)"
                            }}
                        >
                            Choose from over 1&nbsp;Million icons
                        </h1>
                        <img
                            src={require("../../../img/auth/rotating_icons@2x.png")}
                            style={{
                                width: "600px",
                                height: "600px",
                                position: "absolute",
                                pointerEvents: "none",
                                animation:
                                    "spin-continuous-centered 120s infinite linear"
                            }}
                        />
                    </div>
                </section>
            </div>
        );
    }
}

class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {}
        };
    }

    render() {
        let err,
            fld,
            errors = this.props.errors,
            fields = {
                login: {
                    className: "",
                    labelClassName: "show",
                    placeholderText: "Email Address",
                    labelText: "Email"
                },
                password: {
                    className: "",
                    labelClassName: "show",
                    placeholderText: "Password",
                    labelText: "Password"
                }
            };

        for (fld in errors) {
            err = errors[fld];
            if (!fields[fld] || fld === "userId") {
                // Remap userId or unknown errors to password
                // this shows users errors under password box
                fld = "password";
            }
            fields[fld].className += " error on";
            fields[fld].labelClassName += " error on";
            fields[fld].labelText = err;
        }

        return (
            <div id="signup">
                <section
                    id="form-container"
                    className="signup-styles columns five"
                >
                    <h2 className="auth-headline">Welcome back, friend.</h2>

                    <form
                        id="login-form"
                        action="/accounts/login/"
                        method="POST"
                        className="new-form dark-form form-pro"
                    >
                        <ol className="margin-b-xl">
                            <li>
                                <input
                                    id="user_id"
                                    className={fields.login.className}
                                    maxLength="254"
                                    name="login"
                                    type="text"
                                    required
                                    placeholder={fields.login.placeholderText}
                                    onFocus={this.props.clearErrors}
                                />

                                <label
                                    htmlFor="user_id"
                                    className={fields.login.labelClassName}
                                >
                                    {fields.login.labelText}
                                </label>
                                <label
                                    htmlFor="user_id"
                                    className="ui_icon ui_user"
                                />
                            </li>

                            <li>
                                <input
                                    id="id_password"
                                    maxLength="4096"
                                    name="password"
                                    type="password"
                                    placeholder={
                                        fields.password.placeholderText
                                    }
                                    onFocus={this.props.clearErrors}
                                    className={fields.password.className}
                                    required
                                />

                                <label
                                    htmlFor="id_password"
                                    className={fields.password.labelClassName}
                                >
                                    {fields.password.labelText}
                                </label>
                                <label
                                    htmlFor="id_password"
                                    className="ui_icon ui_lock"
                                />
                            </li>
                        </ol>

                        <ProcessButton
                            callback={this.props.doLogin}
                            resetState={this.props.confirmAuth}
                            buttonState={this.props.authStatus}
                            buttonText="Log In"
                            iconClass="ui_key"
                            extraClass="full-width"
                            color="blue"
                        />
                        <div>
                            <a
                                className="forgot-password text-link dark"
                                href="/accounts/password/reset/"
                            >
                                forgot your password?
                            </a>
                        </div>
                        <p className="or">or</p>

                        <a
                            className="button facebook ui_facebook full-width"
                            href={
                                "/accounts/facebook/login/?next=" +
                                window.location.pathname +
                                window.location.search.replace("&", "%26")
                            }
                        >
                            <span>Log In with Facebook</span>
                        </a>
                    </form>
                </section>
            </div>
        );
    }
}

class Auth_Modal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showLogin: false,
            showRegister: false,
            authStatus: "initial",
            errors: {}
        };
    }

    doLogin(e) {
        // This name doesn't make sense.
        let $form;
        if (e !== void 0) {
            e.preventDefault();
        }
        if (this.state.showLogin === true) {
            $form = $("#login-form");
        } else {
            $form = $("#create-account");
        }
        if (this.prevalidateForm($form) === true) {
            return Dispatcher.dispatch({
                actionType: "authenticateUser",
                url: $form.attr("action"),
                formData: $form.serialize()
            });
        }
    }

    prevalidateForm($form) {
        let field;
        let fld;
        let requiredFields;
        let selector;
        let termsCheckbox;
        let errors = {};
        requiredFields = {
            userId: "#user_id",
            email: "#id_email",
            password: "#id_password",
            password1: "#id_password1",
            accept_terms: "#accept_terms"
        };

        if (Object.keys(errors).length > 0) {
            this.setState({
                errors
            });
            return false;
        }
        return true;
    }

    confirmAuth() {
        return Dispatcher.dispatch({
            actionType: "confirmAuth"
        });
    }

    clearErrors() {
        return Dispatcher.dispatch({
            actionType: "clearAuthErrors"
        });
    }

    onCloseModal() {
        return this.setState({
            showLogin: false,
            showRegister: false,
            errors: {}
        });
    }

    showLogin(e) {
        if (e !== void 0) {
            e.preventDefault();
        }
        let newState = {
            showLogin: true,
            showRegister: false,
            authStatus: "initial",
            errors: {}
        };
        Dispatcher.dispatch({
            ...newState,
            actionType: "setLoginRegisterState"
        });
        return this.setState(newState);
    }

    showRegister(e) {
        if (e !== void 0) {
            e.preventDefault();
        }
        let newState = {
            showLogin: false,
            showRegister: true,
            authStatus: "initial",
            errors: {}
        };
        Dispatcher.dispatch({
            ...newState,
            actionType: "setLoginRegisterState"
        });
        return this.setState(newState);
    }

    userStoreChange() {
        let userState = UserStore.getAll(),
            userErrors = UserStore.getErrors(),
            state = {
                authStatus: UserStore.getCurrentStatus(),
                errors: userErrors
            };

        if (userState.showRegister !== null) {
            state.showRegister = userState.showRegister;
        }
        if (userState.showLogin !== null) {
            state.showLogin = userState.showLogin;
        }
        return this.setState(state);
    }

    downloadStoreChange() {
        let downloadPhase = DownloadStore.getCurrentPhase();
        if (downloadPhase === "AUTHENTICATE") {
            return this.setState({
                showRegister: true
            });
        }
    }

    componentDidMount() {
        $document.bind(
            "keydown",
            (_this => event => {
                let esc;
                esc = 27;
                switch (event.keyCode) {
                    case esc:
                        if (_this.state.authStatus !== "PROCESSING") {
                            return _this.onCloseModal();
                        }
                }
            })(this)
        );
        UserStore.addListener("change", this.userStoreChange.bind(this));
        return DownloadStore.addListener(
            "change",
            this.downloadStoreChange.bind(this)
        );
    }

    componentWillUnmount() {
        UserStore.removeListener("change", this.userStoreChange.bind(this));
        return DownloadStore.removeListener(
            "change",
            this.downloadStoreChange.bind(this)
        );
    }

    render() {
        let form, modal, extraButton;

        if (this.state.showLogin) {
            extraButton = (
                <a
                    href="#"
                    onClick={this.showRegister.bind(this)}
                    className="sign-in-button button ui_user small"
                >
                    <span>Create a free account</span>
                </a>
            );
            form = (
                <LoginForm
                    errors={this.state.errors}
                    authStatus={this.state.authStatus}
                    doLogin={this.doLogin.bind(this)}
                    clearErrors={this.clearErrors.bind(this)}
                    showRegister={this.showRegister.bind(this)}
                />
            );
        }
        if (this.state.showRegister) {
            extraButton = (
                <a
                    href="#"
                    onClick={this.showLogin.bind(this)}
                    className="sign-in-button button ui_key small"
                >
                    <span>Log in</span>
                </a>
            );
            form = (
                <RegisterForm
                    errors={this.state.errors}
                    authStatus={this.state.authStatus}
                    doLogin={this.doLogin.bind(this)}
                    clearErrors={this.clearErrors.bind(this)}
                    showLogin={this.showLogin.bind(this)}
                />
            );
        }
        if (typeof form !== "undefined") {
            modal = (
                <BaseModal
                    modalContent={form}
                    onCloseModal={this.onCloseModal.bind(this)}
                    modalType="split-modal"
                    extraButton={extraButton}
                />
            );
        }
        return <section>{modal}</section>;
    }
}

export default Auth_Modal;
